import axios from "axios"

export default{
    ReferenceModel: {
        async Table(data){
            const response = await axios.post(`/api/vehiclereferencemodel/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/vehiclereferencemodel/update' : '/api/vehiclereferencemodel/create',data)
            return response
        },
        async GetById(id){
            const response = await axios.get(`/api/vehiclereferencemodel/get/${id}`)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/vehiclereferencemodel/delete/${id}`)
            return response
        },
        async CalculateTireCost(data){
            const response = await axios.post(`/api/vehiclereferencemodel/calculatetirecost`,data)
            return response
        },
        async List(){
            const response = await axios.get(`api/vehiclereferencemodel/select/list`)
            return response
        },
        TireLifeAndType:{
            async CreateOrUpdate(update,data){
                const response = await axios.post(update ? `api/vehiclereferencemodel/update/vehicletypetirelifereference`:`api/vehiclereferencemodel/create/vehicletypetirelifereference`,data)
                return response
            }
        }
    },
    DraftPrice:{
        async GetSampleExcel(){
            const response = await axios.get(`/api/draftofferpricecalculation/downloadsample`,{
                responseType: 'blob',
            })
            return response
        },
        async UploadExcel(data){
            const response = await axios.post(`/api/draftofferpricecalculation/upload`,data,{headers: { "Content-Type": "multipart/form-data" },})
            return response
        },
        async GetResultExcel(url){
            const response = await axios.get(url,{ responseType: 'blob', })
            return response
        },
        async Calculate(data){
            const response = await axios.post('/api/draftofferpricecalculation/calculatedraftofferprice',data)
            return response
        },
        async OtherDistrict(data,tolls,highways){
            const response = await axios.get(`/api/draftofferpricecalculation/get/otherdistricts/${data}/${tolls}/${highways}`)
            return response
        },
        async CenterDistrict(data,tolls,highways){
            const response = await axios.get(`/api/draftofferpricecalculation/get/centerdistricts/${data}/${tolls}/${highways}`)
            return response
        },
        async SelectedProvinceCalculate(data){
            const response = await axios.post(`/api/draftofferpricecalculation/get/centerdistrictsbyselectedprovinces`,data)
            return response
        },
        async CalculateDistance(data){
            const response = await axios.post(`/api/draftofferpricecalculation/calculatedistance`,data)
            return response
        },
        async CalculateDistanceMultiple(data){
            const response = await axios.post(`/api/draftofferpricecalculation/calculatelistdistance`,data)
            return response
        },
    },
    DraftPriceOperation:{
        async Table(data){
            const response = await axios.post(`/api/draftofferoperations/table`,data)
            return response
        },
        async Create(data){
            const response = await axios.post('/api/draftofferoperations/create',data)
            return response
        },
        async Get(data){
            const response = await axios.get(`/api/draftofferoperations/get/draftofferdetail/${data}`)
            return response
        },
        async GetAll(data){
            const response = await axios.get(`/api/draftofferoperations/get/alldetail/${data}`)
            return response
        },
        async Preview(data){
            const response = await axios.get(`/api/draftofferoperations/get/preview/${data}`)
            return response
        },
        async PreviewLastVersion(data){
            const response = await axios.get(`/api/draftofferoperations/get/lastversionofdraftoffer/${data}`)
            return response
        },
        async Update(data){
            const response = await axios.post(`/api/draftofferoperations/update/draftofferprice`,data)
            return response
        },
        async SendDraftOffer(data){
            const response = await axios.post(`/api/draftofferoperations/senddrafttocustomer/${data}`)
            return response
        },
        async GetCustomerChangeRequest(data){
            const response = await axios.get(`/api/draftofferoperations/get/customer/changerequests/${data}`)
            return response
        },
        async Action(data){
            const response = await axios.post(`/api/draftofferoperations/action/changerequest`,data)
            return response
        },
        async History(data){
            const response = await axios.get(`/api/draftofferoperations/get/changerequesthistory/${data}`)
            return response
        }
    },
    TireReferenceModel:{
        async Table(data){
            const response = await axios.post(`/api/tirereferencemodeloperations/tirereferencemodel/table`,data)
            return response
        },
        async CreateOrUpdate(update,data){
            const response = await axios.post(update ? '/api/tirereferencemodeloperations/tirereferencemodel/update' : '/api/tirereferencemodeloperations/tirereferencemodel/create',data)
            return response
        },
        async Update(data){
            const response = await axios.post('/api/tirereferencemodeloperations/tirereferencemodel/update',data)
            return response
        },
        async GetById(id){
            const response = await axios.get(`/api/tirereferencemodeloperations/tirereferencemodel/get/${id}`)
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/tirereferencemodeloperations/tirereferencemodel/delete/${id}`)
            return response
        },
        async List(){
            const response = await axios.get(`api/tirereferencemodeloperations/tirereferencemodel/select/list`)
            return response
        },
        async UpdateMultiple(data){
            const response = await axios.post('/api/tirereferencemodeloperations/effectiveprice/update/multiple',data)
            return response
        }
    },
    AgreementValue:{
        async Update(data){
            const response = await axios.post('/api/draftofferoperations/update/draftofferagreementvalue',data)
            return response
        },
        async Get(data){
            const response = await axios.get(`/api/draftofferoperations/get/draftofferagreementvalue/${data}`)
            return response
        }
        
    },
}